"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listPlans = listPlans;
exports.currentPlan = currentPlan;
exports.purchasePlan = purchasePlan;
exports.verifySubscription = verifySubscription;
exports.changePlan = changePlan;
exports.unsubscribe = unsubscribe;
exports.billingHistory = billingHistory;
exports.paymentMethod = paymentMethod;
exports.updatePaymentMethod = updatePaymentMethod;
exports.latestSubscription = latestSubscription;
exports.signup = signup;
exports.preview = preview;
exports.PaymentMethodError = exports.endpoints = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _get = _interopRequireDefault(require("lodash/get"));

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _constants = require("../utils/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var endpoints = {
  listPlans: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/premium/plans");
    }
  },
  currentPlan: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/premium");
    }
  },
  purchasePlan: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/premium");
    }
  },
  changePlan: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/premium");
    }
  },
  unsubscribe: {
    method: 'DELETE',
    url: function url() {
      return "/".concat(_constants.API_V1, "/premium");
    }
  },
  billingHistory: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/premium/history");
    }
  },
  verifySubscription: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/premium/verify_subscription");
    }
  },
  paymentMethod: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/premium/payment_method");
    }
  },
  updatePaymentMethod: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/premium/payment_method");
    }
  },
  latestSubscription: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/premium/latest_subscription");
    }
  },
  signup: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/premium/new_user");
    }
  },
  preview: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/premium/preview");
    }
  }
};
exports.endpoints = endpoints;

function listPlans() {
  return _listPlans.apply(this, arguments);
}

function _listPlans() {
  _listPlans = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var optionals, _endpoints$listPlans, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            optionals = _utils.defaultOptionals;
            _endpoints$listPlans = endpoints.listPlans, method = _endpoints$listPlans.method, url = _endpoints$listPlans.url;
            _context.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            res = _context.sent;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: res.result.map(_utils.planFormatter)
            }));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _listPlans.apply(this, arguments);
}

function currentPlan(_x) {
  return _currentPlan.apply(this, arguments);
}

function _currentPlan() {
  _currentPlan = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref) {
    var auth, optionals, _endpoints$currentPla, method, url, res, accountOwner;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            auth = _ref.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$currentPla = endpoints.currentPlan, method = _endpoints$currentPla.method, url = _endpoints$currentPla.url;
            _context2.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context2.sent;
            accountOwner = res.result.accountOwner;
            return _context2.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: _objectSpread(_objectSpread({}, (0, _utils.planFormatter)(res.result.featurePlan)), {}, {
                owner: accountOwner
              })
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _currentPlan.apply(this, arguments);
}

function purchasePlan(_x2, _x3, _x4) {
  return _purchasePlan.apply(this, arguments);
}

function _purchasePlan() {
  _purchasePlan = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(planId, paymentMethodId, _ref2) {
    var auth, optionals, _endpoints$purchasePl, method, url, res, success, _res$result, subscription, plan;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            auth = _ref2.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              planId: planId,
              paymentMethodId: paymentMethodId
            }))(_utils.defaultOptionals);
            _endpoints$purchasePl = endpoints.purchasePlan, method = _endpoints$purchasePl.method, url = _endpoints$purchasePl.url;
            _context3.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context3.sent;
            success = res.status === 200;

            if (!(res.result === null)) {
              _context3.next = 9;
              break;
            }

            throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);

          case 9:
            _res$result = res.result, subscription = _res$result.subscription, plan = _res$result.plan;
            return _context3.abrupt("return", {
              success: success,
              subscription: subscription,
              plan: (0, _utils.planFormatter)(plan)
            });

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _purchasePlan.apply(this, arguments);
}

function verifySubscription(_x5, _x6) {
  return _verifySubscription.apply(this, arguments);
}

function _verifySubscription() {
  _verifySubscription = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(subscriptionId, _ref3) {
    var auth, optionals, _endpoints$verifySubs, method, url, res, success, _res$result2, subscription, plan;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            auth = _ref3.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              subscriptionId: subscriptionId
            }))(_utils.defaultOptionals);
            _endpoints$verifySubs = endpoints.verifySubscription, method = _endpoints$verifySubs.method, url = _endpoints$verifySubs.url;
            _context4.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context4.sent;
            success = res.status === 200;

            if (!(res.result === null)) {
              _context4.next = 9;
              break;
            }

            throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);

          case 9:
            _res$result2 = res.result, subscription = _res$result2.subscription, plan = _res$result2.plan;
            return _context4.abrupt("return", {
              success: success,
              subscription: subscription,
              plan: plan
            });

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _verifySubscription.apply(this, arguments);
}

function changePlan(_x7, _x8) {
  return _changePlan.apply(this, arguments);
}

function _changePlan() {
  _changePlan = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(planId, _ref4) {
    var auth, optionals, _endpoints$changePlan, method, url, res, success, _res$result3, subscription, plan;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            auth = _ref4.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              planId: planId
            }))(_utils.defaultOptionals);
            _endpoints$changePlan = endpoints.changePlan, method = _endpoints$changePlan.method, url = _endpoints$changePlan.url;
            _context5.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context5.sent;
            success = res.status === 200;

            if (!(res.result === null)) {
              _context5.next = 9;
              break;
            }

            throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);

          case 9:
            _res$result3 = res.result, subscription = _res$result3.subscription, plan = _res$result3.plan;
            return _context5.abrupt("return", {
              success: success,
              subscription: subscription,
              plan: (0, _utils.planFormatter)(plan)
            });

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _changePlan.apply(this, arguments);
}

function unsubscribe(_x9) {
  return _unsubscribe.apply(this, arguments);
}

function _unsubscribe() {
  _unsubscribe = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref5) {
    var auth, optionals, _endpoints$unsubscrib, method, url, res;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            auth = _ref5.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$unsubscrib = endpoints.unsubscribe, method = _endpoints$unsubscrib.method, url = _endpoints$unsubscrib.url;
            _context6.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context6.sent;
            return _context6.abrupt("return", res);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _unsubscribe.apply(this, arguments);
}

function billingHistory(_x10) {
  return _billingHistory.apply(this, arguments);
}

function _billingHistory() {
  _billingHistory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref6) {
    var auth, optionals, _endpoints$billingHis, method, url, res;

    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            auth = _ref6.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$billingHis = endpoints.billingHistory, method = _endpoints$billingHis.method, url = _endpoints$billingHis.url;
            _context7.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context7.sent;
            return _context7.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: res.result || []
            }));

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _billingHistory.apply(this, arguments);
}

function paymentMethod(_x11) {
  return _paymentMethod.apply(this, arguments);
}

function _paymentMethod() {
  _paymentMethod = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(_ref7) {
    var auth, optionals, _endpoints$paymentMet, method, url, res;

    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            auth = _ref7.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$paymentMet = endpoints.paymentMethod, method = _endpoints$paymentMet.method, url = _endpoints$paymentMet.url;
            _context8.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context8.sent;
            return _context8.abrupt("return", res);

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _paymentMethod.apply(this, arguments);
}

function updatePaymentMethod(_x12, _x13) {
  return _updatePaymentMethod.apply(this, arguments);
}

function _updatePaymentMethod() {
  _updatePaymentMethod = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(paymentMethodId, _ref8) {
    var auth, optionals, _endpoints$updatePaym, method, url, res;

    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            auth = _ref8.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              paymentMethodId: paymentMethodId
            }))(_utils.defaultOptionals);
            _endpoints$updatePaym = endpoints.updatePaymentMethod, method = _endpoints$updatePaym.method, url = _endpoints$updatePaym.url;
            _context9.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context9.sent;

            if (!(res.status !== 200)) {
              _context9.next = 8;
              break;
            }

            throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);

          case 8:
            return _context9.abrupt("return", res);

          case 9:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _updatePaymentMethod.apply(this, arguments);
}

function latestSubscription(_x14) {
  return _latestSubscription.apply(this, arguments);
}

function _latestSubscription() {
  _latestSubscription = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(_ref9) {
    var auth, optionals, _endpoints$latestSubs, method, url, res, result;

    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            auth = _ref9.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$latestSubs = endpoints.latestSubscription, method = _endpoints$latestSubs.method, url = _endpoints$latestSubs.url;
            _context10.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context10.sent;

            if (!(res.status !== 200)) {
              _context10.next = 8;
              break;
            }

            throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);

          case 8:
            result = (0, _mapValues["default"])(res.result, function (value, key) {
              switch (key) {
                case 'plan':
                case 'pendingPlan':
                  return (0, _utils.planFormatter)(value);

                default:
                  return value;
              }
            });
            return _context10.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: result
            }));

          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _latestSubscription.apply(this, arguments);
}

var PaymentMethodError = /*#__PURE__*/function (_Error) {
  (0, _inherits2["default"])(PaymentMethodError, _Error);

  var _super = _createSuper(PaymentMethodError);

  function PaymentMethodError() {
    var _this;

    (0, _classCallCheck2["default"])(this, PaymentMethodError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.name = 'PaymentMethodError';
    return _this;
  }

  return PaymentMethodError;
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));

exports.PaymentMethodError = PaymentMethodError;

function signup(_x15, _x16, _x17) {
  return _signup.apply(this, arguments);
}

function _signup() {
  _signup = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(planId, paymentMethodId, _ref10) {
    var email, password, captcha, recoveryMethod, firstName, lastName, birthday, tnc, optIn, featureSubscriptionId, domainSubscriptionId, price, currency, _ref10$freeTrial, freeTrial, _email$split, _email$split2, username, userDomain, optionals, _endpoints$signup, method, url, res, token, success, csrf, orderId, sessionId, _res$result4, featureSubscription, domainSubscription, plan;

    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            email = _ref10.email, password = _ref10.password, captcha = _ref10.captcha, recoveryMethod = _ref10.recoveryMethod, firstName = _ref10.firstName, lastName = _ref10.lastName, birthday = _ref10.birthday, tnc = _ref10.tnc, optIn = _ref10.optIn, featureSubscriptionId = _ref10.featureSubscriptionId, domainSubscriptionId = _ref10.domainSubscriptionId, price = _ref10.price, currency = _ref10.currency, _ref10$freeTrial = _ref10.freeTrial, freeTrial = _ref10$freeTrial === void 0 ? false : _ref10$freeTrial;
            // Split body by domain type
            _email$split = email.split('@'), _email$split2 = (0, _slicedToArray2["default"])(_email$split, 2), username = _email$split2[0], userDomain = _email$split2[1];
            optionals = (0, _functools.compose)((0, _utils.withSignUpHeaders)({
              username: username,
              password: password,
              captcha: captcha,
              recoveryMethod: recoveryMethod
            }), (0, _utils.withSignUpBody)(recoveryMethod, firstName, lastName, birthday, tnc, optIn, {
              planId: planId,
              paymentMethodId: paymentMethodId,
              featureSubscriptionId: featureSubscriptionId,
              domainSubscriptionId: domainSubscriptionId,
              domainPrice: price,
              currency: currency,
              domain: userDomain,
              freeTrial: freeTrial
            }))(_utils.defaultOptionals);
            _endpoints$signup = endpoints.signup, method = _endpoints$signup.method, url = _endpoints$signup.url;
            _context11.next = 6;
            return (0, _requests.request)(url(), method, optionals);

          case 6:
            res = _context11.sent;
            token = res.getHeader('x-Auth-Token');
            success = false;
            _context11.t0 = res.status;
            _context11.next = _context11.t0 === 102 ? 12 : _context11.t0 === 103 ? 13 : 14;
            break;

          case 12:
            throw new PaymentMethodError(res.message);

          case 13:
            throw new PaymentMethodError('');

          case 14:
            if (!(res.status !== 200 && !res.result)) {
              _context11.next = 16;
              break;
            }

            throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);

          case 16:
            csrf = res.getHeader('x-Csrf-Token');
            orderId = res.getHeader('x-Order-Id');
            sessionId = res.getHeader('x-Super-Session-Id');
            _res$result4 = res.result, featureSubscription = _res$result4.featureSubscription, domainSubscription = _res$result4.domainSubscription, plan = _res$result4.plan;
            return _context11.abrupt("return", {
              success: success,
              featureSubscription: featureSubscription,
              domainSubscription: domainSubscription,
              plan: plan,
              token: token,
              csrf: csrf,
              orderId: orderId,
              sessionId: sessionId
            });

          case 21:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _signup.apply(this, arguments);
}

function preview(_x18, _x19) {
  return _preview.apply(this, arguments);
}

function _preview() {
  _preview = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(planId, _ref11) {
    var auth, qty, optionals, _endpoints$preview, method, url, res, result;

    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            auth = _ref11.auth, qty = _ref11.qty;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              planId: planId,
              qty: qty
            }))(_utils.defaultOptionals);
            _endpoints$preview = endpoints.preview, method = _endpoints$preview.method, url = _endpoints$preview.url;
            _context12.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context12.sent;
            result = (0, _mapValues["default"])(res.result, function (value, key) {
              switch (key) {
                case 'plan':
                  return (0, _utils.planFormatter)(value);

                case 'invoiceItems':
                  return value || [];

                default:
                  return value;
              }
            });
            return _context12.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: result
            }));

          case 8:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _preview.apply(this, arguments);
}
//# sourceMappingURL=premium.js.map